module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('tbody', _vm._l((_vm.clientes), function(c) {
    return _c('tr', {
      class: !c.lido ? 'txtBold clienteMsg' : 'clienteMsg',
      on: {
        "click": function($event) {
          return _vm.cliente(c.id)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticClass: "img-msg",
      attrs: {
        "src": c.img
      },
      on: {
        "error": function($event) {
          return _vm.syncClient(c.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.nome.toUpperCase()) + " "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!c.lido),
        expression: "!c.lido"
      }],
      staticClass: "fa fa-exclamation",
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": ".6em"
      }
    }, [_vm._v("Ultima mensagem: " + _vm._s(_vm._f("ajusteDate")(c.mensagem[c.mensagem.length - 1].date)))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0d7ec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/ListUsers.vue
// module id = 1254
// module chunks = 1